import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ApiRequest from 'core/api/request';
import TrackUtil from 'core/utils/TrackUtil';
import { BrazeUtil } from 'core/utils';

class SignupWidget extends Component {
	state = {
		loading: false,
		success: false,
		errored: false,
		alreadySubscribed: false,
	}

	resetState = () => {
		this.setState({
			loading: false,
			success: false,
			errored: false,
			alreadySubscribed: false,
		});
	}

	trackEvent = (eventName, email = false) => {
		TrackUtil.trackEvent("signup_widget", {
			statjoy: [{
				step_name: eventName,
				cus1: email
			}],
			fullstory: [{
				'step_name_str': eventName,
			}],
		});
		TrackUtil.trackEvent(eventName, {
			fullstory: [],
		});

		if (email) {
			// Braze braze
			const user = window?.cj?.user;
			if (user) {
				TrackUtil.trackEvent("signup_widget", {
					braze: [{
						step: eventName,
					}],
				});
			}
		}
	}

	submitHandler = ({ email }) => {
		this.setState({ loading: true });
		const { trackEvent } = this;
		const { source } = this.props;
		const data = { email, source };

		ApiRequest.post('/email_signup/', data)
			.then(({ email }) => {
				trackEvent('signup_widget_success', email);
				this.setState({
					success: true,
					loading: false,
				});
			})
			.catch(e => {
				// Let subscribers know if they are already active list memebers
				if (e.fetchResponse.status === 400) {
					const errMsg = e.errors[0];
					if (errMsg.includes('already subscribed')) {
						this.setState({
							success: true,
							loading: false,
							alreadySubscribed: true,
						});
						return;
					}
				}
				trackEvent('signup_widget_error', email);
				this.setState({
					errored: true,
					loading: false,
				});
			});
	}

	onObserve = () => {
		const { trackEvent } = this;
		trackEvent('signup_widget_viewed');
	}

	render () {
		const passedProps = {
			...this.state,
			...this.props,
			onObserve: this.onObserve,
			submitHandler: this.submitHandler,
			errorOnClickBtn: this.resetState,
		};

		const { children } = this.props;

		return children({ ...passedProps });
	}

	static propTypes = {
		children: PropTypes.func.isRequired,
		source: PropTypes.string.isRequired,
	}

	static defaultProps = {
		source: 'footer_widget',
	}
}

export default SignupWidget;
